module.exports = __webpack_public_path__ + "img/ImpotAD_logo.4b67dc71.svg";